<div style="max-width: 900px" class="m-auto">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between">
        <div class="d-flex gap-2 align-items-center">
          <button class="btn btn-light border d-flex text-center" (click)="navigateBack()">
                            <span class="material-symbols-outlined" style="font-size: 18px; width: 10px; line-height: 20px;">
                                arrow_back_ios
                            </span>
          </button>
          <h1 class="h5 m-0">
            {{title}}
          </h1>
        </div>

        <div class="d-flex gap-2">
          <ng-content select="[headerRight]"></ng-content>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12" [class]="{'col-md-8': sideContent.children.length}">
      <ng-content></ng-content>
    </div>
    <div #sideContent class="col-12 col-md-4">
      <ng-content select="[sideContent]"></ng-content>
    </div>
  </div>
</div>
